// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

//
import { Api } from "#/api";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { Headline } from "../../../components/headline/Headline";
import { Gallery } from "../../../components/gallery/Gallery";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import { SoftkonfiguratorItem } from "./softkonfigurator_item/SoftkonfiguratorItem";

// data
import { LG, MD, SM } from "./layouts";
import { Layout } from "#/common/interfaces/conversionworld/Layout";
import { Branche } from "../../../common/interfaces/conversionworld/Branche";

enum Size {
  SM = "sm",
  MD = "md",
  LG = "lg",
}

interface ItemData {
  img: string;
  title: string;
  link: string;
}

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
    Gallery,
    ImageAspectRatio,
    SoftkonfiguratorItem,
  },
})
export class SoftconfiguratorModule extends ModuleBase {
  private size: Size = Size.SM;

  get layout(): Layout {
    return this.mapSizeToLayout(this.size, this.items.length);
  }

  get maxElementsInLayout(): number {
    return Math.max.apply(null, this.layout.order);
  }

  get groups() {
    return this.buildBranchDesign(this.items, this.size);
  }

  get headline() {
    if (this.$store.page.page!.route_parameter["branchenId"]) {
      if (this.branche) {
        return this.branche.question;
      }

      return this.instance["einsatzzweck"]["headline"];
    } else {
      return this.instance["branche"]["headline"];
    }
  }

  get text() {
    if (this.$store.page.page!.route_parameter["branchenId"]) {
      if (this.branche) {
        return this.branche.answer;
      }

      return this.instance["einsatzzweck"]["text"];
    } else {
      return this.instance["branche"]["text"];
    }
  }

  get backgroundImage() {
    if (this.$store.page.page!.route_parameter["branchenId"] && this.branche) {
      return this.branche.images.bg_image_without_vehicle;
    }

    if (this.branchen.length > 0) {
      return this.branchen[Math.floor(Math.random() * this.branchen.length)]
        .images.bg_image_without_vehicle;
    }

    return "";
  }

  get branchen() {
    return this.$store.conversionWorld.branchen;
  }

  get branche() {
    if (this.$store.page.page!.route_parameter["branchenId"]) {
      return this.branchen.find(
        (b) => b.slug == this.$store.page.page!.route_parameter["branchenId"]
      );
    }

    return null;
  }

  get items(): ItemData[] {
    if (this.branche) {
      return this.branche.loesungen.map((l) => {
        return {
          link: l.link,
          title: l.alternative_title,
          img: l.images.softconfiguration,
        };
      });
    }

    return this.branchen.map((b) => {
      return {
        link: b.link,
        img: b.images.softconfiguration,
        title: b.title,
      };
    });
  }

  created() {
    this.$store.conversionWorld.loadBranchen(this.$store.page.page!.id);
    this.size = this.getSize();

    window.addEventListener("resize", this.handleResize);
  }

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }

  getBackgroundColorFromInstance(instance: object) {
    return this.instance["color"];
  }

  private handleResize(e: Event) {
    this.size = this.getSize();
  }

  private getSize(): Size {
    if (window.innerWidth >= 1200) return Size.LG;
    else if (window.innerWidth >= 468) return Size.MD;
    else return Size.SM;
  }

  private mapSizeToLayout(size: Size, i: number) {
    if (size === Size.LG) return LG[i];
    else if (size === Size.MD) return MD[i];
    else return SM[i];
  }

  private buildBranchDesign(list: ItemData[], size: Size) {
    let groups;
    if (!this.layout) {
      groups = this.buildGroupsDefault(list);
    } else {
      const { order, styling } = this.layout;
      groups = this.buildGroups(list, order);
    }

    /*const isSwap = size === Size.MD ? true : false;
    if (isSwap) groups = this.swapGroups(groups);*/

    return groups;
  }

  private buildGroupsDefault(list: ItemData[]): ItemData[][] {
    let groups: ItemData[][] = [];

    list.forEach((item, index) => {
      let group = index % 5;
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(item);
    });

    return groups;
  }

  private buildGroups(list: ItemData[], layout: number[]): ItemData[][] {
    if (this.size == Size.MD) {
      if (list.length == 1) {
        return [[list[0]]];
      }

      if (list.length == 2) {
        return [[list[0]], [list[1]]];
      }

      const groups: ItemData[][] = [[], [], []];
      list.forEach((item, index) => {
        let gIndex = (index + 1) % 3;
        groups[gIndex].push(item);
      });

      return groups;
    }

    const groups: ItemData[][] = [];
    let index = 0;
    layout.forEach((count) => {
      const subArr = list.slice(index, index + count);
      index += count;
      groups.push(subArr);
    });
    return groups;
  }

  private swapGroups(list: ItemData[][]) {
    const groups: ItemData[][] = [];
    if (list.length < 3) {
      groups.push(list[1]);
      groups.push(list[0]);
    } else {
      groups.push(list[2]);
      groups.push(list[0]);
      groups.push(list[1]);
    }
    return groups;
  }

  private onBack(event) {
    event.preventDefault();
    window.history.back();
  }
}
